import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "@/router/views/BaseMixer"; // Import the BaseMixer class
import Swal from "sweetalert2";
import simplebar from "simplebar-vue";
import twoFactorConfigMachine from "../machines/twoFactorConfigMachine";
import { SettingModule } from "@/store/modules/settings.module";
import { VerifyTwoFactorAuthModel } from "@/store/models/users/verifyTwoFactorAuthDTO";
import { interpret } from "xstate";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import copy from "copy-to-clipboard";
let TwoFactorConfigComponent = /** @class */ (() => {
    let TwoFactorConfigComponent = class TwoFactorConfigComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.machine = twoFactorConfigMachine.withContext({
                passWordError: "",
                passCodeError: "",
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
            this.passWord = "";
            this.showPassword = false;
            this.isCopyText = false;
            this.twoFactorAuth = new VerifyTwoFactorAuthModel();
        }
        send(event) {
            this.machineService.send(event);
        }
        verifyTwoFactorAuth() {
            this.validate("verifyTwoFactorAuth").then((response) => {
                if (response) {
                    this.send({
                        type: "VERIFYING_TWO_FACTOR",
                        twoFactorAuth: this.twoFactorAuth,
                    });
                }
            });
        }
        showTwoFactorAuthModal() {
            this.machineService.send("ENABLE_TWO_FA");
        }
        disableTwoFactorAuth() {
            this.validate("disableTwoAuth").then((response) => {
                if (response) {
                    Swal.fire({
                        title: `Are you sure?`,
                        text: "This will disable your two factor registration with this app. Please ensure that you remove the applicable 2FA entry from your Authenticator App in the Mobile.",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#f46a6a",
                        cancelButtonColor: "#f46a6a",
                        confirmButtonText: "Disable",
                        cancelButtonText: "Cancel",
                    }).then((result) => {
                        if (result.value) {
                            this.send({
                                type: "DISABLE_TWO_FA",
                                password: this.passWord,
                            });
                        }
                    });
                }
            });
        }
        successTwoFactorAuth() {
            this.machineService.send("SUCCESS_TWO_FA");
        }
        manageTwoFactorAuth() {
            this.machineService.send("MANAGE_TWO_FA");
        }
        showModal() {
            this.machineService.send("GET_TWO_FACTOR_CONFIG");
        }
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        }
        copyText() {
            if (this.recoveryCodes.length > 0) {
                const codesAsString = this.recoveryCodes.join("\n");
                copy(codesAsString);
                this.isCopyText = true;
                setTimeout(() => {
                    this.isCopyText = false;
                }, 2000);
            }
        }
        // public copyCode(code) {
        //     if (code != "") {
        //         copy(code);
        //         this.copiedIndex = code;
        //         setTimeout(() => {
        //             this.copiedIndex = null;
        //         }, 2000);
        //     } else {
        //     }
        // }
        // <span class="tooltip-copy" v-if="copiedIndex == props.row.fileUrl">Copied!</span>
        get twoFactorAuthConfig() {
            return SettingModule.twoFactorAuthConfig;
        }
        get recoveryCodes() {
            return SettingModule.recoveryCodes;
        }
        get twoFactorAuthStatus() {
            return SettingModule.twoFactorAuthStatus;
        }
        get showLoader() {
            return this.previousState.matches("modalActive.manageTwoFactorAuth.disablingTwoFactorAuth");
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                if (state.hasTag("loadedRecoveryCodes")) {
                    this.twoFactorAuth = new VerifyTwoFactorAuthModel();
                }
                if (!state.hasTag("showDisableUI")) {
                    this.passWord = "";
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    TwoFactorConfigComponent = __decorate([
        Component({
            name: "TwoFactorConfigComponent",
            components: {
                simplebar,
                SectionLoader,
            },
        })
    ], TwoFactorConfigComponent);
    return TwoFactorConfigComponent;
})();
export default TwoFactorConfigComponent;
